import { FlexRow } from '@/components/common/Flex';
import { Goal } from '@common/goals';
import { EntityViewHeader } from '../common/EntityView';
import PartnerAvatar from '../common/PartnerAvatar';
import { Subheader } from '../common/Typography';
import GoalIconCircle from './GoalIconCircle';

const GoalDetailHeader = ({ goal }: { goal: Goal }) => {
    return (
        <EntityViewHeader>
            <FlexRow align="center">
                <GoalIconCircle type={goal.type} mr={3} />
                <Subheader>{goal.name}</Subheader>
            </FlexRow>

            {!goal.isMine && goal.shareStatus !== 'SHARED' && <PartnerAvatar />}
        </EntityViewHeader>
    );
};
export default GoalDetailHeader;
